import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router'
import { Observable } from 'rxjs'

export interface ComponentCanDeactivate {
  canDeactivate: () => boolean | Observable<boolean>
}

@Injectable({
  providedIn: 'root'
})
export class UnsavedChangesGuard {
  canDeactivate(
    component: ComponentCanDeactivate,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    const currentPath = currentState.url.substring(1).split('/').slice(0, -1)
    const nextPath = nextState.url.substring(1).split('/').slice(0, -1)

    return JSON.stringify(currentPath) !== JSON.stringify(nextPath)
      ? component.canDeactivate()
      : true
  }
}
